import { TransportModeHelper } from '../../../helpers/transport-mode.helper';
import type { ILine } from '../../../models/line.model';
import { TransportSubMode } from '../../../models/transport-sub-mode.enum';
import MunicipalityApiModel from './municipality.api-model';

export default class LineApiModel {
  public static mapToBusinessModel(apiModel: LineApiModel): ILine {
    return {
      gid: apiModel.gid,
      name: apiModel.name,
      shortName: apiModel.shortName,
      transportMode: TransportModeHelper.parse(apiModel.transportMode),
      directionName: apiModel.directions?.length > 0 ? apiModel.directions[0] : undefined,
      backgroundColor: apiModel.backgroundColor,
      foregroundColor: apiModel.foregroundColor,
      borderColor: apiModel.borderColor,
      municipalities: apiModel.municipalities ? apiModel.municipalities.map(MunicipalityApiModel.mapToBusinessModel) : undefined,
      appliesFrom: undefined,
      appliesUpto: undefined,
      contractorId: undefined,
      isPublicTransport: undefined,
      technicalLineNumber: undefined,
      transportSubMode: TransportSubMode.unknown,
      isWheelchairAccessible: undefined,
      designation: apiModel.designation,
      transportAuthorityGid: undefined,
    };
  }

  gid!: string;
  name!: string;
  shortName!: string;
  transportMode!: string;
  directions!: string[];
  backgroundColor!: string;
  foregroundColor!: string;
  borderColor!: string;
  municipalities!: MunicipalityApiModel[];
  designation!: string | undefined;
}
